module.exports = __webpack_public_path__ + "img/lumen.12f167ee.png";